module.exports = __webpack_public_path__ + "img/icon-prevention-menu-covid.41d71956.svg";